<template>
  <page-outline :title="pageTitle">
    <template slot="pageContent">
      <b-row class="justify-content-start mb-5">
        <b-col cols="4" sm="3" md="2" xl="1">
          <back-button :returnUrl="returnUrl"></back-button>
        </b-col>
      </b-row>
      <remote-folder-configuration-form v-model="config" :readonly="!editMode"></remote-folder-configuration-form>
      <b-row class="justify-content-end">
        <b-col cols="4" lg="2" xl="1" v-if="mode === 'create'">
          <b-button v-if="mode === 'create'"
            @click="createConfig" variant="primary">
            <i class="fa-light fa-save"></i>
            <span>{{ $t('common.sve') }}</span>
          </b-button>
        </b-col>
        <b-col cols="4" lg="2" xl="1" v-if="mode === 'details' && editMode === false && canEditConfig">
          <b-button variant="primary"
            @click="editModeActivate">
            <i class="fa-light fa-pencil"></i>
            <span>{{ $t('administration.edit') }}</span>
          </b-button>
        </b-col>
        <b-col cols="4" lg="2" xl="1" v-if="mode === 'details' && editMode === false && canDeleteConfig">
          <b-button variant="primary"
            @click="deleteConfig">
            <i class="fa-light fa-trash"></i>
            <span>{{ $t('rights.delete') }}</span>
          </b-button>
        </b-col>
        <b-col cols="4" lg="2" xl="1" v-if="mode === 'details' && editMode === true">
          <b-button variant="primary"
            @click="editConfig">
            <i class="fa-light fa-save"></i>
            <span>{{ $t('common.sve') }}</span>
          </b-button>
        </b-col>
      </b-row>
    </template>
  </page-outline>
</template>

<script>

import FormAccordion from '@/components/common/FormAccordion.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import {errorMessageAlert} from '@/helpers/alert'
import backButton from "@/components/common/backButton.vue"
import Spinner from '@/components/common/spinner.vue'
import RemoteFolderConfigurationForm from '@/pages/routing/RemoteFolder/RemoteFolderConfigurationForm.vue'

import {loadPage} from '@/helpers/routing'

export default {
  name: 'RemoteFolderConfigurationDetails',
  components: {
    'back-button': backButton,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline,
    'remote-folder-configuration-form': RemoteFolderConfigurationForm,
    'spinner': Spinner
  },
  props: {
    mode: {
      type: String,
      default: 'create'
    }
  },
  computed: {
    canDeleteConfig () {
      return this.$engine.firstOn().rights.rightIs('remoteFolderConfig_delete', true)
    },
    canEditConfig () {
      return this.$engine.firstOn().rights.rightIs('remoteFolderConfig_edit', true)
    },
    pageTitle () {
      return this.mode === 'details' ? this.$t('Webheader.remotefolder_details') : this.$t('Webheader.remotefolder_add')
    },
  },
  data () {
    return {
      activateSpinner: false,
      editMode: false,
      name: '',
      path: '',
      returnUrl: '/routing/remoteFolderConfig/-1',
      savedConfig: [],
      config: {}
    }
  },
  created () {
    this.activateSpinner = true

    if (this.mode === 'details') {
      this.savedConfig = this.$engine.firstOn().routing.config.clickedConfig
      this.fillFields()
      this.$engine.firstOn().routing.config.clickedConfig = {}
    } else {
      this.editMode = true
    }

    this.$f7.initPullToRefresh()
    this.activateSpinner = false
  },
  mounted () {
  },
  beforeDestroy () {
  },
  watch: {
  },
  methods: {
    createConfig () {
      let that = this

      if (this.formHasError()) {
        return
      }

      let params = {
        Path: this.config.path,
        Name: this.config.name
      }
      this.$engine.firstOn().routing.config.remoteFolder.create(params)
      .then(resp => {
        that.$f7.modal({
          title: that.$t('common.routing.config_added'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        loadPage(that, {url: '/routing/remoteFolderConfig/-1'})
      })
      .catch(e => {
        errorMessageAlert(e, that)
        that.okMessageBox(that.$t('common.routing.config_addition_error'))
      })
    },
    deleteConfig () {
      let that = this
      this.$f7.modal({
        title: this.$t('common.routing.config_deletion_confirm'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              let params = {
                IdRemoteFolder: that.savedConfig.IdRemoteFolder
              }
              that.$engine.firstOn().routing.config.remoteFolder.delete(params)
              .then(resp => {
                that.$f7.alert('', that.$t('common.routing.config_deleted'))
                loadPage(that, {url: '/routing/remoteFolderConfig/-1'})
              })
              .catch(error => {
                errorMessageAlert(error, that)
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    editConfig () {
      let that = this

      if (this.formHasError()) {
        return
      }

      let params = {
        Path: this.config.path,
        Name: this.config.name,
        IdRemoteFolder: this.savedConfig.IdRemoteFolder
      }
      this.$engine.firstOn().routing.config.remoteFolder.edit(params)
      .then(resp => {
        that.$f7.modal({
          title: that.$t('common.routing.config_edited'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        loadPage(that, {url: '/routing/remoteFolderConfig/-1'})
      })
      .catch(e => {
        errorMessageAlert(e, that)
        that.okMessageBox(that.$t('common.routing.config_edition_error'))
      })
    },
    editModeActivate () {
      this.editMode = true
    },
    fillFields () {
      this.config.name = this.savedConfig.Name
      this.config.path = this.savedConfig.Path
    },
    formHasError () {
      if (this.config.name === undefined || this.config.length === 0) {
        this.okMessageBox(this.$t('common.routing.config_name_missing'))
        return true
      }
      if (this.config.path === undefined || this.config.path.length === 0) {
        this.okMessageBox(this.$t('common.routing.path_missing'))
        return true
      }
      return false
    },
    goBack () {
      if (this.editMode === true) {
        this.editMode = false
        this.fillFields()
      }
      else {
        loadPage(this, {url: '/routing/remoteFolderConfig/-1'})
      }
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    }
  }
}
</script>
